/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import * as API from '../../http/api';
import * as Modals from '../modals';
import ModalSearchSpaceList from "../modals/ModalSearchSpaceList";
import { channelTxs, statusTxs, noDataComponent } from '../../util/DataObject';
import { openlightbox } from '../../util/Functions';
import { format } from '../../util/DateUtil';
import DataTable from "react-data-table-component";
import { customStyles2 } from "../../util/TableStyles"

import { useTxPending } from './space-features/hooks/useTxPending';
import { initDay, endDay, parseDate } from '../elements/DateRangePicker';
import { DateRangePicker } from '../elements/DateRangePicker';
import CustomPagination from '../elements/CustomPagination';
import DataTx from '../elements/DataTx';

import { Tooltip, Typography, TextField, Switch, MenuItem, IconButton } from "@mui/material";
import { RequestQuote, FilterAlt, Paid, Search, InsertInvitation, AdminPanelSettings, Visibility, VisibilityOff } from "@mui/icons-material";
import { FlexGrid, Card, Button, Skeleton } from '@albo-ui/core'
import { CLABE_SPEI } from '../../util/RegEx'; 

import moment from 'moment';
import 'moment/locale/es';

const SpaceListTx = (props: any) => {
	moment.locale('es');
    const { columns, data, loading: loadingTable, onHandleSearch } = useTxPending(props.changeAlert)
	const [showPending, setShowPending] = useState(false);


	const [rowsPerPage, setRowsPerPage] = useState(50)
	const [space, setSpace] = useState({
		cdate: null,
		balance: {
			total: null
		}
	});
	const [amount, setAmount] = useState('');
	const [spaceUuid, setSpaceUuid] = useState('');
	const [clabe, setClabe] = useState('');
	const [clabeSpei, setClabeSpei] = useState(null);
	const [info, setInfo] = useState({});
	const [page, setPage] = useState(1);
	const [cards, setCards] = useState([]);
	const [cache, setCache] = useState({});
	const [txType, setTxType] = useState('');
	const [channel, setChannel] = useState('');
	const [status, setStatus] = useState('');
	const [card, setCard] = useState('');
	const [trackingKey, setTrackingKey] = useState('');
	const [banks, setBanks] = useState({});
	const [filter, setFilter] = useState(false);
	const [newCols, setNewCols] = useState(props.item.data.columns);
	const [contentTable, setContentTable] = useState(props.item);
	const [company, setCompany] = useState(false);
	const [downloadPDF, setDownloadPDF] = useState(false);
	const [tracking, setTracking] = useState(false);
	const [txs, setSpaceTxs] = useState(props.item.data.content);
	const [hasFilter, setHasFilter] = useState(false);
	const [customer,setCustomer] = useState({});
	const history = useHistory();

	const [newDates, setNewDates] = useState({
        startDate: initDay,
        endDate: endDay,
    });
    const [isValid, setIsValid] = useState(false);


	useEffect(() => {
		if(props['config']['actions'].indexOf('tracking') > -1){
			setTracking(true);
		}
		if(props.item.data && props.item.data.customer){
			setCustomer(props.item.data.customer);
		}
		if (props.item.hasOwnProperty('init') && props.item.init) {
			setNewCols(props.item.data.columns);
			setContentTable(props.item);
		}
		if (props.next === 'search') {
			let banks = { undefined: 'NA' };
			for (let i in props.catalogs.banks) {
				const bank = props.catalogs.banks[i]
				banks = { ...banks, [bank.k]: bank.v }
			}
			setBanks(banks);

			if(!spaceUuid){
				let selectedAcc = props.item.data.spaces.filter((item) => item.accountNumber === props.item.data.accountNumber)
				selectedAcc.length > 0 ? selectSpace(selectedAcc[0].uuid) : selectSpace("Sin N° de cuenta");
			}
		}
		if (props.next) {
			props.updateNext('');
			if (props.item.hasOwnProperty('init') && props.item.init) {
				verifyFields(true);
			}
			updateCache(page, props.item.data.content);
			updateCards(props.item.data.content);
			setFilter(true);
		}
		setCompany(props.item.data.company);
		if(!spaceUuid){
			let selectedAcc = props.item.data.spaces.filter((item) => item.accountNumber === props.item.data.accountNumber)
			selectedAcc.length > 0 ? setSpaceUuid(selectedAcc[0].uuid) : setSpaceUuid("Sin N° de cuenta");
			selectedAcc.length > 0 && selectedAcc[0]["references"] && selectedAcc[0]["references"]["clabe"] ? setClabe(selectedAcc[0]["references"]["clabe"]) : setClabe("No aplica")
			selectedAcc.length > 0 && selectedAcc[0]["references"] && selectedAcc[0]["references"]["clabe_spei"] ? setClabeSpei(selectedAcc[0]["references"]["clabe_spei"]) : setClabeSpei(null)
		}

		if (props['config']['actions'].indexOf('download') > -1) {
			let spacesFind = props['item']['data']['spaces'];
				let sUuid = spaceUuid;
			if (!sUuid && props.item.data.spaces[0]) {
				sUuid = props.item.data.spaces[0].uuid;
			}
			let spaceS = {};
			for (let i = 0; i < spacesFind.length; i++) {
				if (spacesFind[i]['uuid'] == sUuid) {
				spaceS = spacesFind[i]
				}
			}

			if (spaceS.hasOwnProperty('owner')) {
				if (spaceS['owner']['application_uuid'] == '3' || spaceS['owner']['application_uuid'] == '4') {
					
					for (let i = 0; i < props.item.data.columns.length; i++) {
						if (props.item.data.columns[i] && props.item.data.columns[i].hasOwnProperty('download')) {
							delete props.item.data.columns[i];
						}
					}
					setNewCols(props.item.data.columns);
					setDownloadPDF(true);
				} else {
					for (let i = 0; i < props.item.data.columns.length; i++) {
						if (props.item.data.columns[i].hasOwnProperty('download')) {
							delete props.item.data.columns[i];
						}
					}
					setNewCols(props.item.data.columns);
					setDownloadPDF(false);
				}
			} else {
				for (let i = 0; i < props.item.data.columns.length; i++) {
					if (props.item.data.columns[i].hasOwnProperty('download')) {
						delete props.item.data.columns[i];
					}
				}
				setNewCols(props.item.data.columns);
				setDownloadPDF(false);
			}
		}

	}, [props.item.data.content]);

	useEffect(() => {
		if (filter) {
			setFilter(false);
			filterData(txType, trackingKey, card, page);
		}
	}, [filter]);

	const updateCards = (content) => {
		const pans = [];
		for (let i in content) {
			if (content[i].panMasked && !pans.includes(content[i].panMasked)) {
				pans.push(content[i].panMasked);
			}
		}
		const cards = [];
		for (let i in pans) {
			cards.push({
				label: pans[i],
				value: pans[i]
			});
		}
		setCards(cards);
	}

	useEffect(() => {
		verifyFields(false);
	}, []);

	const verifyFields = (init) => {
		if (!hasField('amount')) {
			let cols = newCols;
			if (init) {
				cols = props.item.data.columns;
			}
			let nC = [];
			for (let i = 0; i < cols.length; i++) {
				if (cols[i]['key'] != 'amountFormated') {
				nC.push(cols[i]);
				}
			}
			let newContent = contentTable;
			if (init) {
				newContent = props.item;
			}
			newContent['data']['columns'] = nC;
			for (let i = 0; i < newContent['data']['content'].length; i++) {
				delete newContent['data']['content'][i]['new_balance'];
				delete newContent['data']['content'][i]['previous_balance'];
			}
			setContentTable(JSON.parse(JSON.stringify(newContent)));
		}
	}

	const onSelectSpace = (event: React.ChangeEvent<{ value: unknown }>) => {
		let value = event.target.value as string;
		for (let i = 0; i < props.item.data.spaces.length; i++) {
			if (props.item.data.spaces[i].uuid === value) {
				const s = props.item.data.spaces[i];
				setClabe(s["references"]["clabe"] || "No aplica")
				setClabeSpei(s["references"]["clabe_spei"] || null)
				break;
			}
		}
		setSpaceUuid(JSON.parse(JSON.stringify(event.target.value)));
		findTx(value, 1);
	}
	const onSelectTxType = (event: React.ChangeEvent<{ value: unknown }>) => {
		let value = event.target.value as string;
		setTxType(value);
		filterData(value, trackingKey, card, page);
	}
	const onSelectStatus = (event: React.ChangeEvent<{ value: unknown }>) => {
		let value = event.target.value as string;
		let filters = []
		filters.push(
			{start_date: newDates.startDate},
			{end_date: newDates.endDate}
		)
		if(value){
			filters.push({"status": value})
		}
		if(channel){
			filters.push({"channel": channel})
		}
		if(amount){
			filters.push({"amount": amount})
		}
		setStatus(value);		
		findTxAdv(filters)
	}
	const onSelectChannel = (event: React.ChangeEvent<{ value: unknown }>) => {
		let value = event.target.value as string;
		let filters = []
		filters.push(
			{start_date: newDates.startDate},
			{end_date: newDates.endDate}
		)
		if(value){
			filters.push({"channel": value})
		}
		if(status){
			filters.push({"status": status})
		}
		if(amount){
			filters.push({"amount": amount})
		}
		setChannel(value);
		findTxAdv(filters)
	}
	const onSelectCard = (event: React.ChangeEvent<{ value: unknown }>) => {
		let card = event.target.value as string;
		setCard(card);
		filterData(txType, trackingKey, card, page);
	}

	const onSearchAmount = () => {
		let filters = []
		filters.push(
			{start_date: newDates.startDate},
			{end_date: newDates.endDate}
		)
		if(amount){
			filters.push({"amount": Number(amount)})
		}
		findTxAdv(filters)
	}

	const filterData = (txType, trackingKey, card, page) => {
		removeInfos();
		const content = cache[page]; 
		if (txType === '' && trackingKey === '' && card === '') {
			props.item.data.content = content;
			return;
		} 
		const movimientosAux = [];
		
		if(trackingKey.length >= 3){
			for (let i = 0; i < content.length; i++) { 			
				if ((txType === '' || txType === content[i].category?.key) &&
					(trackingKey === '' 
					||	(content[i].tracking_key.includes(trackingKey) || content[i].uuid.includes(trackingKey)) 
					||	content[i].description.includes(trackingKey) 
					||	(content[i].hasOwnProperty("card") && content[i].card.hasOwnProperty("wallet") && content[i].card.wallet.includes(trackingKey)) 
					|| 	content[i].statusParse.includes(trackingKey) 
					||	(content[i].remote_account.description  && content[i].remote_account.description.includes(trackingKey))  
					) &&
					(card === '' || card === content[i].panMasked)
				) {
					movimientosAux.push(content[i]);
				}
			}
		}

		if(trackingKey.length >= 3){
			setSpaceTxs(movimientosAux);
			props.item.data.content = movimientosAux;
		} else {
			setSpaceTxs(content);
			props.item.data.content = content;
		}
	}

	const changePage = (action, page, rows= rowsPerPage) => {
		removeInfos();
		setPage(page+1);
		let filters = []
		filters.push(
			{start_date: newDates.startDate},
			{end_date: newDates.endDate}
		)
		if(channel){
			filters.push({"channel": channel})
		}
		if(status){
			filters.push({"status": status})
		}
		if(amount){
			filters.push({"amount": amount})
		}
		findTx(spaceUuid, page+1, rows, filters);
		selectSpace(spaceUuid);
	}

	const removeInfos = () => {
		let set = info;
		for (let i in set) {
		if (set[i]) {
			set = { ...set, [i]: false };
			document.getElementById(`option-tr-${i}`).remove();
		}
		}
		setInfo(set);
	}
	const updateCache = (page, values) => {
		setCache({ ...cache, [page]: values });
	}

	const selectSpace = (value) => {
		setSpaceUuid(value);
		for (let i = 0; i < props.item.data.spaces.length; i++) {
			if (props.item.data.spaces[i].uuid === value) {
				const s = props.item.data.spaces[i];
				setSpace(s);
				break;
			}
		}
	}

	const findTxAdv = async (filter, modal = false, page=1, rows= rowsPerPage) => {
		setPage(page);
		if(modal){
			let d = newDates
			filter.map((s) => {
				if(s["start_date"]){
					d.startDate = s["start_date"]
				}
				if(s["end_date"]){
					d.endDate = s["end_date"]
				}
			})
			setNewDates(JSON.parse(JSON.stringify(d)))
		}

		let data = {
			space: { uuid: spaceUuid },
			filter: {
				genericFilters: filter,
				results_per_page: rows,
				page_number: page
			}
		}
		
		props.changeLoader(true);
		let request = await API.service('spaceListTxAdv', data, props.pos, props.changeAlert, props.changeLoader, history);
		
		if (request.status === 200 && request.data.data.response === 'OK') {			
			for (let i = 0; i < request.data.data.widget.length; i++) {
				let widget = request.data.data.widget[i];
				if (widget.type === 'spaceListTxAdv') {
					props.updateNext('filter');
					let cont = contentTable;
					let content = widget.data.content;
					let c = [];
					for (let i = 0; i < content.length; i++) {
						if (props.config.fields.in.indexOf('amount') == -1) {
							delete content[i]['new_balance'];
							delete content[i]['previous_balance'];
						}
					}
					widget.data.content = content;
					setSpaceTxs(content)
					cont['data']['content'] = widget.data.content;
					cont['data']['pagination'] = widget.data.pagination;
					cont['data']['summary'] = widget.data.summary;
					// setContentTable(cont);
				}
			}
		}
		props.changeLoader(false);
	}

	const findTx = async (space= spaceUuid, page=1, rows= rowsPerPage, filters= null) => {
		setChannel("")
		setStatus("")
		setSpaceUuid(space);

		let data = {
			space: {uuid: space},
			filter: {
				genericFilters: [],
				results_per_page: rows,
				page_number: page
			}
		}
		if(filters){
			data["filter"]["genericFilters"] = filters
		} else {
			data["filter"]["genericFilters"].push({start_date: newDates.startDate},{end_date: newDates.endDate})
		}
		props.changeLoader(true);

		let request = await API.service('spaceListTx', data, props.pos, props.changeAlert, props.changeLoader, history);
		if (request.status === 200 && request.data.data.response === 'OK') {
			for (let i = 0; i < request.data.data.widget.length; i++) {
				let widget = request.data.data.widget[i];
				if (widget.type === 'spaceListTx') {
					props.updateNext('filter');
					let cont = contentTable;
					let content = widget.data.content;
					let c = [];
					for (let i = 0; i < content.length; i++) {
						if (props.config.fields.in.indexOf('amount') == -1) {
							delete content[i]['new_balance'];
							delete content[i]['previous_balance'];
						}
					}
					widget.data.content = content;
					setSpaceTxs(content)
					
					cont['data']['content'] = widget.data.content;
					cont['data']['pagination'] = widget.data.pagination;
					cont['data']['summary'] = widget.data.summary;
				}
			}
		}
		props.changeLoader(false);
	}

	const download = async (data) => {
		props.changeLoader(true);
		const isAlbo = data.channel.trim().toLowerCase().indexOf('albo') > -1 ? true : false;
		let account = {};
		for (let i = 0; i < props.item.data.spaces.length; i++) {
			if (props.item.data.spaces[i].uuid == spaceUuid) {
				account = props.item.data.spaces[i];
				break;
			}
		}
		const TX_AB = 'tx.ab';
		const TX_CR = 'tx.cr';
		const REVERSAL = 'reversal';
		const SETTLED = 'settled';
		let reference = data.remote_account.reference;
		const isReference = (reference != null && reference.length > 0);
		let type = data.type;
		let isAb = TX_AB === type;
		let isCr = TX_CR === type;
		let isReversal = REVERSAL === data.operation?.toLowerCase();
		//let isAlbo = data.channel.trim().toLowerCase().includes('albo');
		//let reversal = data.operation?.toLowerCase();
		let bankNameReceipt = 'albo (STP)';
		let nameAccount = '';
		let numberAccount = '';
		let clabeAccount = '';
		let clabeAccountSpei = '';
		let bankNameSource = 'albo (STP)';
		let uuid = data['uuid'];
		if (account.hasOwnProperty('uuid')) {
			nameAccount = (isReversal || isCr) ? account['general']['name'] : '';
			numberAccount = (isReversal || isCr) ? account['accountNumber'] : '';
			clabeAccount = (isReversal || isCr) ? account['references']['clabe_spei'] || account['references']['clabe'] : '';
			clabeAccountSpei = (isReversal || isCr) ? account['references']['clabe_spei'] : '';
		}

		if (isCr && !isAlbo) {
			bankNameReceipt = data.remote_account.bank_name;
		}
		if (isCr && isAlbo) {
			bankNameReceipt = 'albo';
		}

		let source = {};
		let receipt = {};

		/** Si es un cargo o es una devolucion, la fuente es la cuenta */
		if ((isAb && isReversal) || isCr) {
		source = {
			name: nameAccount,
			numberAccount: numberAccount,
			clabe: clabeAccountSpei || clabeAccount,
			bank: clabeAccountSpei ? 'albo' : bankNameSource
		};
		} else if (isAb) {
			if (isAlbo) {
				source = {
				uuid: data.remote_account.uuid
				}
			} else {
				source = {
				bank: findNameBank(data.remote_account.bank_id),
				clabe: data.remote_account.account
				}
			}
		}
		receipt = {
			name: isAb ? customer["name"] : data.remote_account.name,
			amount: data.amount,
			concept: data.concept,
			status: isReversal ? data.description : data.status,
			clabe: isAb ? account['references']['clabe_spei'] || account['references']['clabe'] : (isReference ? data.remote_account.reference : data.remote_account.clabe),
			bank: isAb ? CLABE_SPEI.test(account['references']['clabe_spei'] || account['references']['clabe']) ? 'albo' : 'albo (STP)' : bankNameReceipt,
			dateComplete: moment(new Date(data.cdate)).format('DD [de] MMMM [de] YYYY[,] hh:mm:ss a'),
			trackingKey: data.tracking_key
		};

		const dataVoucher = {
			uuid: uuid,
			nameAccount: props.item.data.dataCompany.name,
			dateMovement: moment(new Date(data.cdate)).format('DD [de] MMMM [de] YYYY'),
			type: data.type,
			receipt: receipt,
			source: source,
		};

		let request = await API.service('downloadVaucher', dataVoucher, props.pos, props.changeAlert, props.changeLoader, history);
		if (request.status == 200 && request.data.data.response == 'OK') {
			window.open(request.data.data.files[0], 'Download');
		}
		props.changeLoader(false);
	}

	const findNameBank = (val) => {
		let name = 'N/A';
		for (let i = 0; i < props.catalogs.banks.length; i++) {
			let bank = props.catalogs.banks[i];
			if (bank['m'][0]['stp_key'] == val) {
				name = bank.v;
				break;
			}
		}
		return name;
	}

	const formatNumber = (amount, decimalCount = 2, decimal = ".", thousands = ",") => {
		try {
			decimalCount = Math.abs(decimalCount);
			decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

			const negativeSign = amount < 0 ? "-" : "+";

			let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
			let j = (i.length > 3) ? i.length % 3 : 0;

			return negativeSign + ' $' + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - parseInt(i)).toFixed(decimalCount).slice(2) : "");
		} catch (e) {
			console.log(e)
		}
	}

	const hasField = (field) => {
		return props?.['config']?.fields?.in?.indexOf('*') > -1 || props?.['config']?.fields?.in?.indexOf(field) > -1
	}

	const showBalance = () => {
		let array = props.item.data.spaces;
		let format = '';
		for(let i = 0; i<array.length; i++){
			if(array[i]['uuid'] == spaceUuid && array[i].hasOwnProperty('balance')){
				format = formatNumber(array[i]['balance']['disposable']);
				break;
			}
		}
		return format;
	}

	const spaceTxTracking = async (item) => {
		props.changeLoader(true);
		let type = '';
		if(item.amount < 0){
			type = 'moneyout';
		} else {
			type = 'moneyin';
		}
		let data = {
			tracking: {
				tracking_key: item.tracking_key,
				type: type
			},
		}

		let request = await API.service('spaceTxTracking', data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == 'OK') {
      let widg = [];
      widg = request.data.data.widget;
      if (widg[0]?.type === 'spaceTxTracking') {
        let title = `Tracking ${item.tracking_key}`;
        let content = widg[0]['content'];
        let contentModal = {
          title: title,
          content: content,
          type: 'spaceTxTracking'
        }

        const as = <Modals.SpaceTxTracking 
          changeAlert={props.changeAlert}
          changeLoader={props.changeLoader}
          contentModal={contentModal}
          key="spaceTxTracking" 
        />
        openlightbox(as);
      }
    }
    props.changeLoader(false);
	}

	const filterRemoveTxDeleted = async () => {
		let auxTxs =[];
		props.changeLoader(true);		  
		if(!hasFilter){
			for(let index=0; index < props.item.data.content.length; index++){
				if( props.item.data.content[index].statusParse !== "deleted"){
					auxTxs.push(props.item.data.content[index])
				}
			}
			setHasFilter(true);
			setSpaceTxs(auxTxs);
		} else {
			setHasFilter(false);
			setSpaceTxs(props.item.data.content);
		}
		props.changeLoader(false);
	}

	const openSearchModal = () =>{
		const as = (
			<ModalSearchSpaceList
				date={newDates}
				pos={props.pos}
				spacesList={props.spacesList}
				spaceUuid={props.spaceUuid}
				changeAlert={props.changeAlert}
				changeLoader={props.changeLoader}
				customer={props.customer}
				filter = {findTxAdv}
			/>
		);
		openlightbox(as);
	}

  	const downloadCsv = async () => {
		props.changeLoader(true);

		const as = <Modals.SpaceTxCsv 
		pos={props.pos}
		changeAlert={props.changeAlert}
		changeLoader={props.changeLoader}
		content={spaceUuid}
		key="spaceTxCsv" 
		/>
		openlightbox(as);

		props.changeLoader(false);
	}

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		setRowsPerPage(JSON.parse(JSON.stringify(event.target.value)));
		changePage(null, 0, parseInt(event.target.value, 10));
	};

	const updateDates = (data, check) => {
		setNewDates({
			startDate: parseDate(data.startDate, "start"),
			endDate: parseDate(data.endDate, "end")
		});
		setIsValid(check);
	}

	const reloadPage = () => {
		findTx(spaceUuid, page);
	}

	const validate = (bool) => {
		return bool ? hasField("vip") : true
	}

	const onShowPending = () => {
		let payload = {
			value: spaceUuid,
			type: "space"
		}
		onHandleSearch(payload);
		return showPending ? setShowPending(false) : setShowPending(true);
	}

	return (
		<Card padding={4} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{ borderColor: "white"}}> 
			<FlexGrid container fullWidth justify="space-between">
				<FlexGrid item>
					<Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}} fontWeight={600}>
						<RequestQuote sx={{ marginRight: 1 }}/> Movimientos
					</Typography>
				</FlexGrid>
				<FlexGrid container justify="flex-end" alignItems='center' spacing={1}>
					{ hasField('txPending') && 
						<Card width='50px' height='40px' alignItems='center' justifyContent='center' style={{padding: 0}}>
						{showPending ?
							<Tooltip title={`Ocultar Tx´s Pendientes`}>
								<VisibilityOff onClick={onShowPending.bind(this)} color='info' sx={{cursor: "pointer"}}/>
							</Tooltip>
							:
							<Tooltip title={`Ver Tx´s Pendientes`}>
								<Visibility onClick={onShowPending.bind(this)} color='info' sx={{cursor: "pointer"}}/>
							</Tooltip>
						
						}
						</Card>
					}
					<Card width='auto' height='auto' alignItems='center' style={{padding: 0}}>
					<Tooltip title="Ocultar Txs borradas">
						<Switch onClick={filterRemoveTxDeleted.bind(this)} />
					</Tooltip>
					</Card>
					<TextField 
						sx={{width: 180}}
						onChange={(e) => setAmount(e.target.value)} value={amount} label={"Monto"} size="small" type={"number"} inputProps={{ style: { width: "100%", textAlign: "initial" } }} 
						InputProps={{endAdornment: (<IconButton onClick={onSearchAmount} ><Search/></IconButton>)}}
					/>
					<DateRangePicker width={400} updateDates={updateDates.bind(this)} startDate={newDates.startDate} endDate={newDates.endDate}/>
					<IconButton disabled={isValid} onClick={() => findTx()} sx={{padding: "0 !important"}} ><Search sx={{padding: "7px", borderRadius: 2, boxSizing: "content-box", color: "white", backgroundColor: !isValid ? "#8bc179" : "#EDF0F4" }}/></IconButton>
					<Button onClick={downloadCsv} buttonType='primary' size='small' style={{borderRadius: 6, height: 35, width: 120 }} >Descargar</Button>
					<Button onClick={openSearchModal} buttonType='primary' size='small' style={{borderRadius: 6, height: 35, width: 40 }} ><FilterAlt/></Button>
				</FlexGrid>
			</FlexGrid>

			<FlexGrid container fullWidth justify="flex-end"  style={{marginTop: 15}}>
				<TextField label="Cuenta" value={spaceUuid} onChange={onSelectSpace} select size="small" style={{width: 220, marginLeft: 10}} >
					{ props.item.data.spaces.map((data) => {
						return <MenuItem key={data.uuid} value={data.uuid}>{data.accountNumber ? data.accountNumber : "Sin N° de Cuenta"}</MenuItem>
					})}
				</TextField>
				<TextField value={card} label="Tarjetas" onChange={onSelectCard} select size="small" style={{width: 220, marginLeft: 10}} >
					<MenuItem value={''}>Tarjeta</MenuItem>
					{ cards.map((data, iData) => {
						return <MenuItem key={data.value} value={iData}>Tarjeta {data.label}</MenuItem>
					})}
				</TextField>
				<TextField label="Tipo de movimiento" value={txType} onChange={onSelectTxType} select size="small" style={{width: 200, marginLeft: 10}} >
					<MenuItem value={''} key={null}>Tipo de movimiento</MenuItem>
					{ props.catalogs.mccs.map((data) => {
						return <MenuItem key={data.k} value={data.k}>{data.v}</MenuItem>
					})}
				</TextField>
				<TextField label="Canal de transacción" value={channel} onChange={onSelectChannel} select size="small" style={{width: 200, marginLeft: 10}} >
				<MenuItem value={''} key={null}>Canal de transacción</MenuItem>
					{ channelTxs.map((data) => {
						return <MenuItem key={data.key} value={data.key}>{data.label}</MenuItem>
					})}
				</TextField>
				<TextField label="Estatus" value={status} onChange={onSelectStatus} select size="small" style={{width: 200, marginLeft: 10}} >
					<MenuItem value={''} key={null}>Estatus</MenuItem>
					{ statusTxs.map((data) => {
						return <MenuItem key={data.key} value={data.key}>{data.label}</MenuItem>
					})}
				</TextField>
			</FlexGrid>

			<FlexGrid container fullWidth justify="flex-end" spacing={1} style={{marginTop: 15, marginBottom: 20}}>
			{ hasField('clabe') && 
				<Card width='auto' padding={1} height='auto' alignItems='center'>
					<AdminPanelSettings fontSize='small' color='secondary'/>
					<Typography variant='body2' mx={1}>CLABE:</Typography>
					<Typography variant='body2'>{clabeSpei || clabe}</Typography>
				</Card>
			}
			{ hasField('cdate') && 
				<Card width='auto' padding={1} height='auto' alignItems='center'>
					<InsertInvitation fontSize='small' color='secondary'/>
					<Typography variant='body2' mx={1}>Apertura:</Typography>
					<Typography variant='body2'>{format(space.cdate)}</Typography>
				</Card>
			}
			{ hasField('balance') && validate(props.item.data.vip) &&
				<>
					<Card width={'auto'} padding={1} height='auto' alignItems='center'>
						<Paid fontSize='small' color='info'/>
						<Typography variant='body2' mx={1}>Saldo actual:</Typography>
						<Typography variant='body2'>{showBalance()}</Typography>
					</Card>
					<Card width={'auto'} padding={1} height='auto' alignItems='center'>
						<Paid fontSize='small' color='warning'/>
						<Typography variant='body2' mx={1}>Cargos:</Typography>
						<Typography variant='body2'>{formatNumber(-1 * props.item.data.summary.cr)}</Typography>
					</Card>
					<Card width={'auto'} padding={1} height='auto' alignItems='center'>
						<Paid fontSize='small' color='success'/>
						<Typography variant='body2' mx={1}>Abonos:</Typography>
						<Typography variant='body2'>{formatNumber(props.item.data.summary.ab)}</Typography>
					</Card>
				</>
			}
			</FlexGrid>
			{ showPending ?
				loadingTable ?
				<Skeleton width="100%" height="100px" />
				:
				<DataTable
					columns={columns}
					data={data}
					customStyles={customStyles2}
					noDataComponent={noDataComponent}
				/>
				:
				<>
				<CustomPagination 
					rows={props.item.data.pagination.totalDocuments}
					page={page - 1}
					rowsPerPage={rowsPerPage}
					handleChangePage={changePage}
					handleChangeRowsPerPage={handleChangeRowsPerPage}
				/>
				<DataTx
					catalogs={props.catalogs}
					headers={props.item.data.columns}
					data={txs}
					spacesList = {props.item.data.spaces}
					spaceUuid = {spaceUuid}
					options={true}
					downloadPDF={downloadPDF}
					banks={banks}
					countries={props.catalogs.country ? props.catalogs.country : []}
					download={download}
					tracking={tracking}
					config={props.config}
					spaceTxTracking={spaceTxTracking}
					pos={props.pos}
					changeAlert={props.changeAlert}
					changeLoader={props.changeLoader}
					customer= {customer}
					dates={newDates}
					reloadPage={reloadPage}
					validateVip={props["item"]["data"]["vip"] ? props?.["config"]?.fields?.in?.indexOf("vip") > -1 ?  true : false : true}
					pagination={{
						rowsPerPage: rowsPerPage,
						totalRows: props.item.data.pagination.totalDocuments,
						page: page
					}}
				/>
				</>
				
			}
		</Card>
	)
}

export default SpaceListTx;